import { Box, Button, Typography, alpha, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import PublicHeader, { PUBLIC_ACCENT } from "./PublicHeader";
import { ROUTES } from "../routes";

/**
 * Catch-all for any URL that matched nothing in router.js. Wears the same
 * site header every logged-out page does (PublicHeader) instead of leaving
 * an empty #root, and offers a way back home.
 *
 * Shell/copy pattern borrowed from PublicLogDetail's SignInCard.
 */
const NotFound = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        backgroundColor: theme.palette.primary.main,
      }}
    >
      <PublicHeader accent={PUBLIC_ACCENT} appPath={ROUTES.developer} />

      <Box sx={{ flex: 1, minHeight: 0, display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
        <Box
          sx={{
            p: 3,
            maxWidth: 420,
            textAlign: "center",
            borderRadius: 2,
            border: `1px solid ${alpha(PUBLIC_ACCENT, 0.35)}`,
            backgroundColor: alpha(PUBLIC_ACCENT, 0.06),
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mb: 1 }}>
            <SearchOffIcon sx={{ fontSize: 18, color: PUBLIC_ACCENT }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
              This page doesn't exist
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
            The link may be broken, or the page may have moved.
          </Typography>
          <Button
            component={RouterLink}
            to={ROUTES.publicHome}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: PUBLIC_ACCENT,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: PUBLIC_ACCENT, filter: "brightness(0.95)" },
            }}
          >
            Back to Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFound;
